export { Selection } from '@fluentui/utilities';
export type { ISelectionOptions } from '@fluentui/utilities';
